export default __webpack_public_path__ + "static/media/GoodMannerInPublic_13.92846704.png";